import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../lib/i18n';

const LanguageContext = createContext(null);

const detectDefaultLanguage = () => {
  const saved = localStorage.getItem('motobiz_lang');
  if (saved) return saved;
  // Auto-detect: default to Bengali for Bangladeshi users
  const browserLang = (navigator.language || navigator.userLanguage || '').toLowerCase();
  if (browserLang.startsWith('bn')) return 'bn';
  // Check timezone as secondary signal for Bangladesh
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz === 'Asia/Dhaka') return 'bn';
  } catch (e) { /* ignore */ }
  return 'en';
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(detectDefaultLanguage);

  useEffect(() => {
    localStorage.setItem('motobiz_lang', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['en']?.[key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'bn' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
